import Thumbnail from "../../images/thumbnail/Thumbnail";
import { Form } from "react-bootstrap";
import { useRef } from "react";

const ImageUploader = ({className="", images=[], setImages, label="", fileLimit=10, allowPdf=false}) => {

    const imageRef = useRef();
    const imageSize = (fileLimit === 1) ? "w-100" : "w-30 w-lg-20";

    const addImages = (e) => {
        Array.from(e.target.files).forEach(image => {
            // only add an image if the max num of images hasn't been reached yet
            if(images.length < fileLimit) setImages(prev => [...prev, image]);
        });
    };

    const removeImage = (removeIndex) => {
        setImages(prev => prev.filter((_, index) => (index !== removeIndex)));
    };


    return (
        <Form.Group className={className} controlId="imagebox" >
            <Form.Label className="ms-3 mb-3 text-white-50">{label}</Form.Label>
            <div className="d-flex gap-2 border-black rounded-3 border-dashed border-white-50 p-2 overflow-x-auto">
                {(images.length < fileLimit) &&
                    <Thumbnail
                        as="button"
                        src={process.env.PUBLIC_URL+"/add_image.png"}
                        className={"p-4 bg-darker d-flex flex-column justify-content-center align-items-center border border-2 flex-shrink-0 "+imageSize}
                        onClick={() => imageRef.current.click()}
                        ariaDescribeBy="add image"
                    />
                }
                {images.map((image, index) => {
                    const imgPadding = !(new RegExp(/^image\/(png|p?jpeg|gif)$/).test(image.type)) ? 3 : 0;
                    return (
                        <Thumbnail
                            as="button"
                            onClick={() => removeImage(index)}
                            className={"flex-shrink-0 hov-shaded p-"+imgPadding+" "+imageSize}
                            key={index}
                            src={((new RegExp(/^image\/(png|p?jpeg|gif)$/).test(image.type)) ? URL.createObjectURL(image)
                                :
                                (new RegExp(/^application\/pdf$/).test(image.type)) ? process.env.PUBLIC_URL+"/default_pdf.png"
                                :
                                process.env.PUBLIC_URL+"/default_file.png"
                            )}
                            removable={true}
                        >
                            {/* {new RegExp(/^application\/pdf$/).test(image.type) && 
                                <div className="d-flex justify-content-center">
                                    <span className="text-truncate position-absolute z-2 bottom-0">{image.name}</span>
                                </div>
                            } */}
                        </Thumbnail>
                    )
                })}
            </div>
            <Form.Control className="hidden" type="file" accept={"image/jpeg,image/gif,image/png"+(allowPdf ? ",application/pdf" : '')} onChange={addImages} ref={imageRef} multiple={fileLimit > 1} />
        </Form.Group>
    );
}

export default ImageUploader;